import React from "react";
import { Badge, Button, styled } from "@mui/material";
import CartPopover from "../general/CartDrawer";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const ButtonsContainer = styled("div")({
  display: "flex",
  gap: "clamp(4px, 1vw, 12px)",
  marginRight: "clamp(1rem, 2vw, 2rem)"
});

const CartButton = styled(Button)({
  textDecoration: "none",
  color: "#1A1A1A",
  padding: "clamp(4px, 2vh, 4px) clamp(8px, 2vw, 10px)", 
  fontSize: "clamp(0.5rem, 1.2vw, 0.9rem)",
  transition: "color 0.3s ease",
  borderColor: "black",
  border: "1px solid #1A1A1A",
  borderRadius: "999px",
  textTransform: "capitalize",
  borderWidth: "1px",
});

const HeaderRightButtons = () => {
  const cartItems = useSelector((state: RootState) => state.cart.cart.items);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isCartOpen = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonsContainer >
        <Badge badgeContent={cartItems.length} color="primary">
          <CartButton
            variant="outlined"
            size="small"
            onClick={handleOpen}
          >
            Cart
          </CartButton>
        </Badge>
      </ButtonsContainer>
      <CartPopover
        anchorEl={anchorEl}
        open={isCartOpen}
        onClose={handleClose}
        items={cartItems}
      />
    </>
  );
};

export default HeaderRightButtons;
